module.exports = __webpack_public_path__ + "static/media/warm-storage-big.bbc5e658.png";